import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "output"];

  connect() {
    this.recalculate();
  }

  recalculate() {
    const inputValues = this.inputTargets.map(({ value }) => parseInt(value, 10));

    if (inputValues.some((value) => isNaN(value))) {
      this.outputTarget.value = "";
    } else {
      const powerInWatts = inputValues.reduce((val, acc) => val * acc, 1);
      const powerInKiloWatts = (powerInWatts / 1000).toFixed(1);
      this.outputTarget.value = `${powerInKiloWatts} kW`;
    }
  }
}
